import { apiFetch } from "./client.js";

const usersCache = new Map();

function teamKey(teamId) {
  return teamId || localStorage.getItem("metora_team_id") || "default";
}

export function clearUsersCache(teamId) {
  if (teamId) {
    usersCache.delete(teamKey(teamId));

    return;
  }

  usersCache.clear();
}

export function fetchUsers(options = {}) {
  const { force = false, ...apiOptions } = options;
  const key = teamKey(apiOptions.teamId);
  const cached = usersCache.get(key);

  if (!force && cached) {
    return cached;
  }

  const promise = apiFetch("/users", apiOptions).catch((err) => {
    usersCache.delete(key);
    throw err;
  });

  usersCache.set(key, promise);

  return promise;
}
